import { useIntl } from 'react-intl';
import Icon from '../../atoms/Icon';
import { ContentHubDynamicShowMore } from '../../organisms/ContentHubTeaser/ContentHubTeaser.styles';

/**
 * @param {ShowMoreButtonProps} props
 * @returns {React.ReactElement | null} The rendered component
 */
const ShowMoreButton = ({ showMore, showMoreCallback }) => {
  const intl = useIntl();
  if (!showMore) return null;

  return (
    <ContentHubDynamicShowMore onClick={showMoreCallback}>
      <Icon icon="ARROW_CTA" />
      {intl.formatMessage({
        id: 'contentHub.teasers.dynamic.showMore',
      })}
    </ContentHubDynamicShowMore>
  );
};

export default ShowMoreButton;
